import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import Avatar from '@material-ui/core/Avatar';
import CardHeader from '@material-ui/core/CardHeader';



const useStyles = makeStyles(theme => ({
    card: {
      display: 'flex',
      margin: '10px',
      backgroundColor: "rgb(238, 243, 246)",
      height: "150px",
      paddingRight: '65px',
      paddingLeft: '30px',
      paddingBottom: '10px',

    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      
    },
    content: {
      flex: '1 0 auto',
      textAlign: 'right',
     
    },
    cover: {
      width: 151,

    },
    controls: {
      display: 'flex',
      alignItems: 'right',
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    playIcon: {
      height: 45,
      width: 45,
    },
  }));


function getInitial(String){
    var res = String.charAt(0);
    return res;
}

function formatDate(sUTC) {
  return new Date(parseInt(sUTC)).toDateString()
}

export default function SocialFeedCard(props) {
    const classes = useStyles();

    return (
      <div className="SocialFeedCard">
        <Card className={classes.card}>
            <CardHeader
        avatar={
          <Avatar aria-label="Recipe" className={classes.avatar}>
            {getInitial(props.user_id)}
          </Avatar>
        }
        />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="h6" variant="h6">
            {props.user_id} is cooking {props.recipe_name}
          </Typography>
          <Typography variant="subtitle1" color="Textsecondary">
            {formatDate(props.timestamp)}
          </Typography>
          <IconButton aria-label="Add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="Share">
          <ShareIcon />
        </IconButton>
        </CardContent>
      </div>
    </Card>
    </div>
  );
}